import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import * as GQL from '~/graphql/generated/client';
import ProjectTable from '~c/components/project-table';

const sampleData = [
  {
    projectName: 'Project Name',
    risk: GQL.AssessmentRiskStatusType.High,
    assessmentCompletion: 21,
    policyAlignment: false,
  },
  {
    projectName: 'Project Name',
    risk: GQL.AssessmentRiskStatusType.Low,
    assessmentCompletion: 44,
    policyAlignment: true,
  },
  {
    projectName: 'Project Name',
    risk: GQL.AssessmentRiskStatusType.Medium,
    assessmentCompletion: 100,
    policyAlignment: true,
  },
];

interface Props {
  className?: string;
}

const ProjectTableDemo: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <ProjectTable
        title="YOUR PROJECTS"
        data={sampleData}
        projectName={(entry) => entry.projectName}
        risk={(entry) => entry.risk}
        assessmentCompletion={(entry) => entry.assessmentCompletion}
        policyAlignment={(entry) => entry.policyAlignment}
        page={0}
        onPageChange={() => {}}
        rowsPerPage={10}
        onRowsPerPageChange={() => {}}
        totalCount={sampleData.length}
      />
    </div>
  );
};

export default muiStyled(ProjectTableDemo)(
  ({ theme }) => css`
    /* Required for MuiCard to shrink/grow */
  `
);
